/**
* @file Fieldset component for phone input
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { FieldsetBase } from '../fieldset-base/fieldset-base';
import { FieldsetProvider } from '../fieldset-provider';
import { ComponentRegistry } from '../../../core/component-registry';
/**
 * Class for the phone fieldset component
 */
var FieldsetPhoneComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FieldsetPhoneComponent, _super);
    /**
     * Constructs a FieldsetPhoneComponent
     */
    function FieldsetPhoneComponent(provider) {
        return _super.call(this, provider) || this;
    }
    /**
     * Register component by the fieldset provider
     */
    FieldsetPhoneComponent.register = function () {
        ComponentRegistry.register('fieldset', 'phone', FieldsetPhoneComponent);
    };
    return FieldsetPhoneComponent;
}(FieldsetBase));
export { FieldsetPhoneComponent };
